import React, { ReactNode } from "react"
import { Button, Modal } from "react-bootstrap"

// other

// React

export type TModalTypes = {
  isShow: boolean
  title: string
  setIsShow: (value: boolean) => unknown
}

/**
 * モーダル
 */
export const ModalOuter: React.FC<TModalTypes & { footer?: ReactNode }> = ({
  isShow,
  setIsShow,
  title,
  footer,
  children,
  ...props
}) => {
  /**
   * モーダルダイアログ非表示時のイベントハンドラ
   *
   */
  const onHideModal = () => {
    setIsShow(false)
  }

  return (
    <Modal
      {...props}
      show={isShow}
      onHide={() => onHideModal()}
      backdrop="static"
      keyboard={false}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton={false}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        {footer}
        <Button variant="secondary" onClick={() => onHideModal()}>
          閉じる
        </Button>
      </Modal.Footer>
      <style >{`
                .modal-content {
                    width: auto;
                }
              `}
      </style>
    </Modal>
  )
}
